import {
    CREATE_COLOR_DETAIL_FAILURE,
    CREATE_COLOR_DETAIL_SUCCESS,
    CREATE_COLOR_DETAIL_REQUEST,
    CREATE_USER_FORM_COLOR_DETAIL,
    FETCH_COLOR_DETAIL_FAILURE,
    FETCH_COLOR_DETAIL_REQUEST,
    FETCH_COLOR_DETAIL_SUCCESS,
    FETCH_SINGLE_COLOR_DETAIL_FAILURE,
    FETCH_SINGLE_COLOR_DETAIL_REQUEST,
    FETCH_SINGLE_COLOR_DETAIL_SUCCESS,
    RESET_USER_FORM_COLOR_DETAIL,
    UPDATE_COLOR_DETAIL_FAILURE,
    UPDATE_COLOR_DETAIL_REQUEST,
    UPDATE_COLOR_DETAIL_SUCCESS,
    DELETE_COLOR_DETAIL_REQUEST,
    DELETE_COLOR_DETAIL_SUCCESS,
    DELETE_COLOR_DETAIL_FAILURE,
    FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS,
    FETCH_COLOR_DETAIL_WITH_ID_SUCCESS,
    FETCH_COLOR_DETAIL_WITH_ID_REQUEST,
    FETCH_COLOR_DETAIL_WITH_ID_FAILURE,
    FETCH_COLOR_SHADE_DYEING_FAILURE,
    FETCH_COLOR_SHADE_DYEING_SUCCESS,
    FETCH_COLOR_SHADE_DYEING_REQUEST,
    FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS1,
    FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST1,
    FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE1
} from './colorDetails.actionsType';

export const COLOR_DETAILS = 'colorDetails';

let initialState = {
    loading: false,
    colorDetails: [],
    colorDetailsWithoutId: [],
    userform: {},
    selectedColorDetail: {},
    errorMessage: '',
    iperrorMessage: '',
    colorDetail: '',
    colorDetailsWithoutId1: [],
    colorShadeDyeing: [],
};

export let colorDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_COLOR_DETAIL_REQUEST:
        case CREATE_COLOR_DETAIL_REQUEST:
        case FETCH_SINGLE_COLOR_DETAIL_REQUEST:
        case UPDATE_COLOR_DETAIL_REQUEST:
        case DELETE_COLOR_DETAIL_REQUEST:
        case FETCH_COLOR_DETAIL_WITH_ID_REQUEST:
        case FETCH_COLOR_SHADE_DYEING_REQUEST:
        case FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST1:
            return {
                ...state,
                loading: true
            };
        case FETCH_COLOR_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                colorDetails: updatePayload
            };
        case FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                colorDetailsWithoutId: updatePayload
            };

        case FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS1:
            return {
                ...state,
                loading: false,
                colorDetailsWithoutId1: updatePayload

            }

        case FETCH_COLOR_SHADE_DYEING_SUCCESS:
            return {
                ...state,
                loading: false,
                colorShadeDyeing: updatePayload
            }
        case FETCH_SINGLE_COLOR_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedColorDetail: updatePayload,
                userform: {
                    description: updatePayload.fldDescription,
                    CShade: updatePayload.fldShadeCode,
                    ColMixInfo: updatePayload.fldColorMixingInfo,
                    pantoneCode: updatePayload.fldPantoneCode
                }
            };
        case CREATE_COLOR_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_COLOR_DETAIL_WITH_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                colorDetail: updatePayload
            };
        case UPDATE_COLOR_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedColorDetail: {}
            };

        case DELETE_COLOR_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedColorDetail: {}
            };
        case FETCH_COLOR_DETAIL_FAILURE:
        case CREATE_COLOR_DETAIL_FAILURE:
        case FETCH_SINGLE_COLOR_DETAIL_FAILURE:
        case UPDATE_COLOR_DETAIL_FAILURE:
        case DELETE_COLOR_DETAIL_FAILURE:
        case FETCH_COLOR_DETAIL_WITH_ID_FAILURE:
        case FETCH_COLOR_SHADE_DYEING_FAILURE:
        case FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE1:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COLOR_DETAIL:
            return {
                ...state,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_USER_FORM_COLOR_DETAIL:
            return {
                ...state,
                userform: {},
                selectedColorDetail: null,
                colorShadeDyeing: []
            };
        default:
            return state;
    }
};
